export default "__VITE_ASSET__01a4abba__"